import {
    Heading as AriaHeading,
    Popover as AriaPopover,
    Button,
    Dialog,
    DialogTrigger,
    OverlayArrow,
} from 'react-aria-components';
import styled from 'styled-components';
import { Box, Spinner } from '../atoms';
import { colors } from '../utils';

const StyledPopover = styled(AriaPopover)<{ maxWidth?: string }>`
    max-width: ${(props) => props.maxWidth ?? 'unset'};
    background-color: ${colors.blue800};
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const StyledButton = styled(Button)`
    border-radius: 16px;
    border: none;
    background-color: ${colors.white};
    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;

    &:hover {
        transform: scale(1.01);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

        cursor: pointer;
    }
`;

const StyledDialog = styled(Dialog)`
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

const StyledArrow = styled(OverlayArrow)`
    top: -18px;
`;

const Container = styled.div`
    position: relative;
`;

const Overlay = styled.div`
    color: ${colors.blue800};
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.6); // optional dim
    pointer-events: auto; // optional: blocks interaction below
`;

const Heading = styled(AriaHeading)``;

export function Tooltip({
    button,
    content,
    showSpinner,
    style,
}: {
    style?: {
        maxWidth?: string;
    };
    showSpinner?: boolean;
    button: React.ReactNode;
    content: {
        title: React.ReactNode;
        body: React.ReactNode;
    };
}) {
    return (
        <DialogTrigger>
            <StyledButton>{button}</StyledButton>
            <StyledPopover
                placement="bottom right"
                offset={15}
                maxWidth={style?.maxWidth}
            >
                <StyledArrow>
                    <svg
                        width="15"
                        height="7"
                        viewBox="0 0 15 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden
                        role="img"
                    >
                        <path d="M7.5 0L15 7H0L7.5 0Z" fill="#2447A8" />
                    </svg>
                </StyledArrow>
                <StyledDialog>
                    <Box direction="column" wrap="nowrap">
                        <Container>
                            <Heading>{content.title}</Heading>
                            {content.body}
                            {showSpinner ? (
                                <Overlay>
                                    <Spinner width="48px" height="48px" />
                                </Overlay>
                            ) : null}
                        </Container>
                    </Box>
                </StyledDialog>
            </StyledPopover>
        </DialogTrigger>
    );
}
